const INTERNAL_TERM_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bdistribution\s+series\b/gi, 'Survey Project'],
  [/\bdistribution\s+plans\b/gi, 'Survey Project instances'],
  [/\bdistribution\s+plan\b/gi, 'Survey Project instance'],
  [/\bslots\b/gi, 'Survey Project instances'],
  [/\bslot\b/gi, 'Survey Project instance']
]

export const translateUserFacingText = (text: string): string => {
  return INTERNAL_TERM_REPLACEMENTS.reduce(
    (translatedText, [pattern, replacement]) => translatedText.replace(pattern, replacement),
    text
  )
}
